import fetch from "@lib/fetch";
import {API} from "../../config";

export const logChannelUser = (data) => {
    return fetch(`${API}/v1/logs/user_channel_signup`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })  
}